/**
 * ⚠️ 중요: NDS Reset Provider 사용 가이드
 *
 * @usage
 * - 디자인 개편 신규 페이지 컴포넌트에서 반드시 이 Provider를 사용해야 합니다.
 *
 * @migration
 * - 디자인 개편 전체 페이지가 실험군 100%로 전환된 이후,
 *   Legacy 스타일을 제거하고 NDS 스타일만 import하도록 수정이 필요합니다.
 *
 * @styles
 * 현재 디자인 개편 페이지에서 사용 중인 스타일 파일:
 *
 * NDS 스타일 (디자인 개편 페이지):
 * - app/scss/app-v2.scss
 * - app/scss/reset-fix-v2.scss
 *
 * Legacy 스타일 (기존 페이지):
 * - app/scss/app.scss
 * - app/scss/reset-fix.scss
 */
const NDSResetProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          html,
          body {
            line-height: 1.33;
            width: 100%;
            height: 100%;
          }

          button {
            /*
             * 전역 레거시 리셋(app/scss/reset-fix.scss)의 button { border: none }이
             * border-style을 none으로 강제해 NDS outlined 버튼(.border 유틸은 width만 지정,
             * style은 Tailwind preflight의 solid에 의존)의 테두리가 사라진다.
             * preflight 기본값(border-width: 0; border-style: solid)을 동일하게 복원해,
             * filled 버튼은 테두리가 없고(width 0) outlined 버튼은 .border 유틸로 1px이 정상 표시되게 한다.
             * border: inherit은 부모 카드의 border를 filled 버튼이 상속하는 버그가 있어 사용하지 않는다.
             */
            border-width: 0;
            border-style: solid;
            margin: 0;
            padding: 0;

            background: transparent;

            /* inherit font & color from ancestor */
            color: inherit;
            font: inherit;

            /* Corrects font smoothing for webkit */
            -webkit-font-smoothing: inherit;
            -moz-osx-font-smoothing: inherit;

            &::-moz-focus-inner {
              border: 0;
              padding: 0;
            }
          }
        `,
        }}
      />
      {children}
    </div>
  )
}

export default NDSResetProvider
